var jsonRender = require("../../interface/jsonRender.js");

function isEmpty(value) {
  if (value === null || value === undefined) return true;
  if (typeof value === "string") return value.trim() === "";
  if (Array.isArray(value)) return value.length === 0;
  if (typeof value === "object") return Object.keys(value).length === 0;
  return false;
}

function escapeText(value) {
  return (value || "").toString()
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/\"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

function valueToText(value) {
  if (value === null || value === undefined) return "";
  if (typeof value === "string") return value;
  if (typeof value === "number") return String(value);
  if (typeof value === "boolean") return value ? "Yes" : "No";
  if (Array.isArray(value)) {
    return value.map(function(item) {
      if (item === null || item === undefined) return "";
      if (typeof item === "object") {
        try {
          return JSON.stringify(item);
        } catch (error) {
          return String(item);
        }
      }
      return String(item);
    }).filter(function(item) {
      return item !== "";
    }).join(", ");
  }
  if (typeof value === "object") {
    try {
      return JSON.stringify(value);
    } catch (error) {
      return String(value);
    }
  }
  return String(value);
}

function normalizePhone(value) {
  var raw = (value || "").toString().trim();
  if (!raw) return "";

  var hasPlus = raw.indexOf("+") === 0;
  var digits = raw.replace(/\D/g, "");
  if (!digits) return raw;

  if (hasPlus) {
    // +1 NANP numbers read as +1 (614) 555-0100, not +1614 555 0100.
    if (digits.length === 11 && digits.indexOf("1") === 0) {
      return "+1 (" + digits.slice(1, 4) + ") " + digits.slice(4, 7) + "-" + digits.slice(7);
    }
    if (digits.length <= 3) return "+" + digits;
    if (digits.length <= 7) {
      return "+" + digits.slice(0, digits.length - 4) + " " + digits.slice(-4);
    }
    return "+" + digits.slice(0, digits.length - 7)
      + " " + digits.slice(-7, -4)
      + " " + digits.slice(-4);
  }

  if (digits.length === 10) {
    return "(" + digits.slice(0, 3) + ") " + digits.slice(3, 6) + "-" + digits.slice(6);
  }

  if (digits.length === 11 && digits.indexOf("1") === 0) {
    return "+1 (" + digits.slice(1, 4) + ") " + digits.slice(4, 7) + "-" + digits.slice(7);
  }

  return raw;
}

function maskText(value, maskChar) {
  var txt = (value || "").toString();
  if (!txt) return "";
  var ch = (maskChar || "\u2022").toString().charAt(0) || "\u2022";
  return new Array(txt.length + 1).join(ch);
}

function jsonLines(lines, className) {
  var safe = Array.isArray(lines) ? lines.filter(function(line) {
    return !!(line || "").toString().trim();
  }) : [];

  if (safe.length === 0) {
    return {
      n: "span",
      c: "ua-control-preview-empty",
      i: "Not provided"
    };
  }

  return {
    n: "div",
    c: className || "ua-control-preview-lines",
    i: safe.map(function(line) {
      return {
        n: "div",
        i: line
      };
    })
  };
}

function renderDoc(doc) {
  return jsonRender.render(doc);
}

module.exports = {
  escapeText: escapeText,
  isEmpty: isEmpty,
  jsonLines: jsonLines,
  maskText: maskText,
  normalizePhone: normalizePhone,
  renderDoc: renderDoc,
  valueToText: valueToText
};
